import { CURRENT_CONFIG as TEST_CONFIG } from './config.test'
import { CURRENT_CONFIG as PRD_CONFIG } from './config.prd'

const MODE = import.meta.env.MODE || 'production'
// 除非指定环境为 test，否则一律视为生产环境
export const CURRENT_CONFIG =
  MODE === 'test' ? TEST_CONFIG : PRD_CONFIG
